import { ProductRow } from './ProductRow';

export class ProductAlternatives extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showAlternatives: false
        }
    }

    renderShowAlternativesButton() {
        if (this.props.item.alternativeProductCollection.length == 0) {
            return null;
        }

        if (this.state.showAlternatives) {
            return null;
        }

        return <button className="btn-show-alternatives btn btn-link btn-sm alternate-btn" onClick={() => { this.setState({ showAlternatives: true }); }}>Show Alternatives</button>;
    }


    renderShowAlternatives() {
        if (!this.state.showAlternatives) {
            return <div className="alt-stock"></div>;
        }

        return <div className="alt-stock open">
            <button className="close" onClick={() => { this.setState({ showAlternatives: false }); }}><i className="icon icon-dropdown-arrow" /></button>
            {this.props.item.alternativeProductCollection.map((item) => {
                return <ProductRow
                    key={"item-row-" + item.stockcode}
                    item={item}
                    canaddtocart={this.props.canAddToCart}
                    limitordertoapprovedstocklist={this.props.limitOrderToApprovedStocklist}
                    limitOrderToTemplateStocklist={this.props.limitOrderToTemplateStocklist}
                    showFullStockInfo={true}
                />
            })}
        </div>
    }

    render() {
        return (
            <div className="item">

                <div className="row">

                    <div className="col-6 col-lg-6 col-sm-6">

                        {this.renderShowAlternativesButton()}

                    </div>

                </div>
                {this.renderShowAlternatives()}
            </div>

        );
    }
}